<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('orders.create')" @invoke-method="invokeMethod($event)" action="openOrderForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetOrders(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.status_id"
                                            :placeholder="$t('lang.status_id')"
                                            :items="order_status"
                                            item-value="option_id"
                                            item-text="option"
                                            prepend-icon="monitor_heart"
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="orders" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openOrderForm(props.item)">
                                <td>{{ props.item.order_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td class="text-center">{{ props.item.order_date }}</td>
                                <td class="text-center">{{ props.item.ship_date }}</td>
                                <td class="text-center">
                                    <v-chip disabled round text-color="white" class="fs-14 text-center" :color="props.item.status_class">
                                        <span style="min-width: 60px">{{ props.item.status }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="orders"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="order_dialog">
                <v-card>
                    <v-form ref="form_order">
                        <v-card-title>
                            <span class="headline">{{ order.order_id ? $t("lang.edit_order") : $t("lang.add_order") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeOrderDialog"
                                :dialog-status="order_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="order_dialog"
                                            v-model="order.order_id"
                                            :label="$t('lang.order_id')"
                                            :counter="showCounter(order.order_id, 'orders.order_id')"
                                            :rules="ifValid('orders.order_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="order.rfq_id"
                                            :label="$t('lang.rfq_id')"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('orders.rfq_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="order.quote_id"
                                            :label="$t('lang.quote_id')"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('orders.quote_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="order.purchase_order_id"
                                            :label="$t('lang.purchase_order_id')"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('orders.purchase_order_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="order.company_id"
                                            :label="`${$t('lang.company_id')} *`"
                                            :items="customers"
                                            item-value="company_id"
                                            item-text="company"
                                            :rules="ifValid('orders.company_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="order.billing_address_id"
                                            :label="`${$t('lang.billing_address_id')} *`"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('orders.billing_address_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="order.shipping_address_id"
                                            :label="`${$t('lang.shipping_address_id')} *`"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('orders.shipping_address_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="order.order_date"
                                            :label="$t('lang.order_date')"
                                            :rules="ifValid('orders.order_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="order.ship_date"
                                            :label="$t('lang.ship_date')"
                                            :rules="ifValid('orders.ship_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="order.payment_term_id"
                                            :label="`${$t('lang.payment_term')} *`"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('orders.payment_term_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="order.exchange_rate_id"
                                            :label="$t('lang.exchange_rate_id')"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('orders.exchange_rate_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="order.subtotal"
                                            :label="$t('lang.subtotal')"
                                            :counter="showCounter(order.subtotal, 'orders.subtotal')"
                                            :rules="ifValid('orders.subtotal')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="order.discount"
                                            :label="$t('lang.discount')"
                                            :counter="showCounter(order.discount, 'orders.discount')"
                                            :rules="ifValid('orders.discount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="order.total_amount"
                                            :label="$t('lang.total_amount')"
                                            :counter="showCounter(order.total_amount, 'orders.total_amount')"
                                            :rules="ifValid('orders.total_amount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="order.comments"
                                            :label="$t('lang.comments')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('orders.comments')"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="order.order_id" color="error" @mouseup.left="$refs.delete_orders.openDialog()">{{ $t("lang.delete") }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeOrderDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveOrders">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_orders"
                :heading="$t('lang.delete_order')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteOrders(order.order_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openOrderForm" },
                { title: this.$t("lang.refresh"), action: "dbGetOrders", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.order_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.company_id"), sortable: false, width: "50%" },
                { text: this.$t("lang.order_date"), sortable: false, align: "center", width: "15%" },
                { text: this.$t("lang.ship_date"), sortable: false, align: "center", width: "15%" },
                { text: this.$t("lang.status"), sortable: false, align: "center", width: "10%" },
            ],
            enableAddModal: false,
            enableEditModal: false,
            customers: null,
            order: {},
            filter: {
                search: "",
                status_id: "",
                company_id: "",
            },
            order_dialog: false,
            dbGetOrders: _.debounce(this.getOrders, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchOrders", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.orders) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchOrders({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.orders) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.refresh();
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetOrders");
        this.$store.commit("resetOptions");
        next();
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.orders.orders_filter,
            page: (state) => state.orders.page,
            rules_orders: (state) => state.orders.rules_orders,
            order_status: (state) => state.options_categories.order_status,
            orders: (state) => state.orders.orders,
            customer_options: (state) => state.customers.customer_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchOrders", "saveOrder", "deleteOrder", "fetchOptions", "fetchCustomers"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openOrderForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    //if (this.customer_options.length == 0)
                    this.fetchCustomers({ body: { options: 1 } });

                    if (this.$refs.form_order) item ? this.$refs.form_order.resetValidation() : this.$refs.form_order.reset();

                    this.$nextTick(() => {
                        this.order = item != null ? this.assignObj2(item, this.rules_orders) : {};
                        this.order_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "order", params: { id: item.order_id } });
                }
            } else {
                if (this.enableAddModal) {
                    //if (this.customer_options.length == 0)
                    this.fetchCustomers({ body: { options: 1 } });

                    if (this.$refs.form_order) item ? this.$refs.form_order.resetValidation() : this.$refs.form_order.reset();
                    this.order_dialog = true;
                } else {
                    this.$router.push({ name: "order" });
                }
            }
        },
        saveOrders() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_order")) {
                    let body = this.prepForm(this.order, this.rules_orders);

                    this.saveOrder({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getOrders();
                                this.closeOrderDialog();
                            } else {
                                this.$router.push({ name: "order", params: { id: data.order_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteOrders(id = null) {
            this.deleteOrder({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getOrders();
                    this.closeOrderDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },
        closeOrderDialog() {
            this.order_dialog = false;
            this.$refs.delete_orders.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getOrders(pg_refresh = false) {
            this.startLoader();

            this.fetchOrders({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.order_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (this.order_status == 0 || force == true) await this.fetchOptions({ body: { slug: "order_status", options: 1 } });

            //if (this.customer_options.length == 0 || force == true)

            this.finishLoader();
        },
    },
};
</script>
